export default {
  state: {
    units: [],
    selfUnits: []
  },
  getters: {
    units: function units(state) {
      return state.units;
    },
    selfUnits: function selfUnits(state) {
      return state.selfUnits;
    }
  },
  mutations: {
    setUnits: function setUnits(state, val) {
      return state.units = val;
    },
    setSeflUnits: function setSeflUnits(state, val) {
      return state.selfUnits = val;
    }
  }
};